module.exports = __webpack_public_path__ + "r-v3/img/ico_check_white.5c98ca96.svg";